import { Language } from "../languages/labels/language.labels";

export function taxDeclarationCompanyList(lang: Language): {code: string, display: string}[] {
  return [
    { code: 'invoicing', display: lang.labels.onInvoicing },
    { code: 'cashing', display: lang.labels.onCashing }
  ]
}

export function taxDeclarationCompanyValue(lang: Language, code: string): string {
  let taxDeclaration = taxDeclarationCompanyList(lang).find((item) => (item.code === code))
  return taxDeclaration ? taxDeclaration.display : lang.labels.undefined
}
